import { render } from "./AddButtonSmall.vue?vue&type=template&id=0f7942a9&scoped=true&ts=true"
import script from "./AddButtonSmall.vue?vue&type=script&lang=ts"
export * from "./AddButtonSmall.vue?vue&type=script&lang=ts"

import "./AddButtonSmall.vue?vue&type=style&index=0&id=0f7942a9&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7942a9"]])

export default __exports__